import React from 'react';
import './OpenLetterModal.scss';

const OpenLetterModal = ({ isOpen, onClose, letterContent }) => {
  if (!isOpen) {
    return null;
  }

  // Remove the "Gary, [timestamp]" lines from the letter content
  const cleanedContent = letterContent.replace(/^Gary, \[[0-9]{2}\/[0-9]{2}\/[0-9]{4} [0-9]{2}:[0-9]{2}\]\n?/gm, '').trim();

  return (
    <div className="open-letter-modal-overlay" onClick={onClose}>
      <div className="open-letter-modal-content" onClick={(e) => e.stopPropagation()}>
        <button className="close-button" onClick={onClose} aria-label="Close Letter">
        </button>
        <h2>An Open Letter from Gary</h2>
        <div className="letter-meta">
          Authored: February 24, 2025
        </div>
        <div className="letter-body">
          {cleanedContent}
        </div>
      </div>
    </div>
  );
};

export default OpenLetterModal; 